import { render, staticRenderFns } from "./setting_wrapper.vue?vue&type=template&id=6591cd0a&"
import script from "./setting_wrapper.vue?vue&type=script&lang=js&"
export * from "./setting_wrapper.vue?vue&type=script&lang=js&"
import style0 from "./setting_wrapper.vue?vue&type=style&index=0&id=6591cd0a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports